
import { Component, Watch } from 'vue-property-decorator';

import { ActivitiesApi } from '@/api/ActivitiesApi';

import { MetaInfo } from 'vue-meta';

import ListPage from '@/views/ListPage.vue';

import { isEmptyValue } from '@/config/functions';
import { mapGetters, mapState } from 'vuex';

@Component({
   metaInfo(): MetaInfo {
      return {
         title: 'Activity Options',
      };
   },
   computed: {
      ...mapState({
         tarification: (s: any) => s.activities.tarification,
         type_of_transfer: (s: any) => s.activities.type_of_transfer,
      }),
      ...mapGetters({
         GP_THRESHOLD: 'activities/GP_THRESHOLD',
      }),
   },
})
export default class Activities extends ListPage {
   fields: any[] = [];

   unfiltered: any[] = [];

   filtered: any[] = [];

   filter: any = {};

   tarification!: any[];

   type_of_transfer!: any[];

   GP_THRESHOLD!: number;

   sort: any = {
      sortBy: '',
      sortDirection: 'asc',
   };

   mounted() {
      this.findOrders();

      this.fields = [
         {
            key: 'o_act_color',
            label: 'Color',
            thAttr: {
               style: 'width: 43px;',
            },
            formatter: (value: string) => (isEmptyValue(value) ? this.default_colors['o_act_color'] : `#${value}`),
         },
         {
            key: 'o_name',
            label: 'Nick',
            sortable: true,
         },
         {
            key: 'o_marketname',
            label: 'Price List Name',
            sortable: true,
         },
         {
            key: 'o_type_transfer',
            label: 'Type of transfer',
            sortable: true,
         },
         {
            key: 'o_listpricenotes',
            label: 'Price List Notes',
            sortable: true,
         },
         {
            key: 'o_activity.o_name',
            label: 'Supplier',
            sortable: true,
         },
         {
            key: 'o_lsp',
            label: 'Curr',
            sortable: true,
            formatter: (value: number) => this.formatterFloat(value),
            colspan: 3,
            title: 'Sale',
         },
         {
            key: 'o_new_lsp',
            label: 'New',
            sortable: true,
            formatter: (value: number) => this.formatterFloat(value),
            colspan: -1,
         },
         {
            key: 'o_price_from',
            label: 'From',
            sortable: true,
            formatter: (value: string) => (!isEmptyValue(value) ? this.formatterDate(value, 'dateFormat') : ''),
            colspan: -1,
         },
         {
            key: 'o_listmingroup',
            label: 'Curr',
            sortable: true,
            colspan: 2,
            title: 'MGS',
         },
         {
            key: 'o_new_minimum',
            label: 'New',
            sortable: true,
            colspan: -1,
         },
         {
            key: 'o_average_gp',
            label: 'Curr',
            sortable: true,
            colspan: 2,
            title: 'Average GP',
            formatter: (value: number, key: string, item: any) => this.formatterFloat(value < item['o_minimum_gp'] ? item['o_minimum_gp'] : value),
            tdClass: (value: number, key: string, item: any) => ({
               'text-strong': item['o_average_gp'] < item['o_minimum_gp'],
               'text-danger': item['o_average_gp'] < this.GP_THRESHOLD,
               'text-success': item['o_average_gp'] >= this.GP_THRESHOLD,
            }),
         },
         {
            key: 'o_new_average_gp',
            label: 'New',
            sortable: true,
            colspan: -1,
            formatter: (value: number, key: string, item: any) =>
               this.formatterFloat(value < item['o_new_minimum_gp'] ? item['o_new_minimum_gp'] : value),
            tdClass: (value: number, key: string, item: any) => ({
               'text-strong': item['o_new_average_gp'] < item['o_new_minimum_gp'],
               'text-danger': value < this.GP_THRESHOLD,
               'text-success': value >= this.GP_THRESHOLD,
            }),
         },
         {
            key: 'o_cost',
            label: 'Curr',
            sortable: true,
            formatter: (value: number) => this.formatterFloat(value),
            colspan: 3,
            title: 'COST',
         },
         {
            key: 'o_new_supp_cost',
            label: 'New',
            sortable: true,
            formatter: (value: number) => this.formatterFloat(value),
            colspan: -1,
         },
         {
            key: 'o_cost_from',
            label: 'From',
            sortable: true,
            formatter: (value: string) => (!isEmptyValue(value) ? this.formatterDate(value, 'dateFormat') : ''),
            colspan: -1,
         },
         {
            key: 'o_addtoprice',
            sortable: true,
            label: 'Add to Price List',
         },
         {
            key: 'o_adrenaline',
            sortable: true,
            label: 'Active on Website',
         },
      ];

      this.filter = {
         ...this.filter,
         o_act_color: this.default_colors['o_act_color'],
         o_price_from: [],
         o_cost_from: [],
      };
   }

   findOrders() {
      if (!this.dataReady) {
         setTimeout(() => this.findOrders(), 1000);
         return;
      }

      this.$store.commit('showLoading');
      this.$store.commit('setItems', { name: 'ready', value: false });

      ActivitiesApi.all({ archive: this.is_archive })
         .then(activities => {
            this.unfiltered = activities;
         })
         .finally(() => {
            this.$store.commit('setItems', { name: 'ready', value: true });
            this.$store.commit('hideLoading');
         });
   }

   changeGroupColor(order: any, o_act_color: string) {
      order.o_act_color = o_act_color;
      ActivitiesApi.update(order.id, { ...order, 'change-group-color': o_act_color });
   }

   sortItems(sortBy: string) {
      this.sort = {
         sortBy,
         sortDirection: sortBy == this.sort.sortBy ? (this.sort.sortDirection == 'asc' ? 'desc' : 'asc') : 'asc',
      };
   }

   @Watch('$route.query', { deep: true })
   changeQuery() {
      this.findOrders();
   }
}
